module.exports = __webpack_public_path__ + "img/croatia.789668b6.png";